import type {
  ArenaActivityEvent,
  ArenaHomePayload,
  ArenaSeason,
  ArenaSeasonStanding,
} from "@/types/services/api-contracts";

import { callEdgeData } from "./_core/edge-call";
import { ARENA_FUNCTION_NAME } from "./_core/function-names";

export const arenaOverviewService = {
  async getArenaHome(): Promise<ArenaHomePayload> {
    return callEdgeData<ArenaHomePayload>(ARENA_FUNCTION_NAME, "get-arena-home", {
      method: "GET",
    });
  },

  async getTeamActivity(groupId?: string): Promise<ArenaActivityEvent[]> {
    return callEdgeData<ArenaActivityEvent[]>(ARENA_FUNCTION_NAME, "get-team-activity", {
      method: "GET",
      params: groupId ? { group_id: groupId } : undefined,
    });
  },

  async getSeasonStandings(filters?: {
    season_id?: string;
    sport_id?: string;
    city?: string;
    limit?: number;
  }): Promise<ArenaSeasonStanding[]> {
    return callEdgeData<ArenaSeasonStanding[]>(ARENA_FUNCTION_NAME, "get-season-standings", {
      method: "GET",
      params: {
        ...(filters?.season_id ? { season_id: filters.season_id } : {}),
        ...(filters?.sport_id ? { sport_id: filters.sport_id } : {}),
        ...(filters?.city ? { city: filters.city } : {}),
        ...(filters?.limit ? { limit: String(filters.limit) } : {}),
      },
    });
  },

  async listSeasons(): Promise<ArenaSeason[]> {
    return callEdgeData<ArenaSeason[]>(ARENA_FUNCTION_NAME, "list-seasons", {
      method: "GET",
    });
  },

  async upsertSeason(data: {
    season_id?: string;
    name: string;
    starts_at: string;
    ends_at: string;
  }): Promise<ArenaSeason> {
    return callEdgeData<ArenaSeason>(ARENA_FUNCTION_NAME, "upsert-season", {
      body: data,
    });
  },

  async activateSeason(data: { season_id: string }): Promise<{
    season: ArenaSeason;
    standings: ArenaSeasonStanding[];
  }> {
    return callEdgeData<{ season: ArenaSeason; standings: ArenaSeasonStanding[] }>(
      ARENA_FUNCTION_NAME,
      "activate-season",
      {
        body: data,
      },
    );
  },

  async closeSeason(data: { season_id: string }): Promise<ArenaSeason> {
    return callEdgeData<ArenaSeason>(ARENA_FUNCTION_NAME, "close-season", {
      body: data,
    });
  },

  async rebuildSeasonStandings(data: { season_id: string }): Promise<{
    season: ArenaSeason;
    standings: ArenaSeasonStanding[];
  }> {
    return callEdgeData<{ season: ArenaSeason; standings: ArenaSeasonStanding[] }>(
      ARENA_FUNCTION_NAME,
      "rebuild-season-standings",
      {
        body: data,
      },
    );
  },
};
